module.exports = __webpack_public_path__ + "img/20190827144406976.5e7d9d6b.jpg";